module.exports = __webpack_public_path__ + "img/19_29.6c11f2b4.png";